var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoReverse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 100",
    enableBackground: "new 0 0 300 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "0,0 300,0 300,100 0,100 0,0  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000",
    points: "33.3,61.3 47,61.3 47,55.9 63.3,55.9 63.3,49.3 47,49.3 47,47.1 63.3,47.1 63.3,39.7 33.3,39.7                 33.3,61.3  "
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#000",
    d: "M81.9,45.6h4.4c2.4,0,3.6,0.5,3.6,1.9c0,1.6-0.7,2.4-3.8,2.4h-4.2                 V45.6L81.9,45.6z M68.3,61.3h13.6v-7H82l6.4,7h16.1l-9.4-8.9c4.2-0.3,8.4-2,8.4-6.3c0-4.1-3.6-6.3-9.7-6.3H68.3V61.3L68.3,61.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000",
    points: "108.6,61.3 139.1,61.3 139.1,55.6 122.3,55.6 122.3,53.6 139.1,53.6 139.1,48.6 122.3,48.6                 122.3,46.5 139.1,46.5 139.1,39.7 108.6,39.7 108.6,61.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000",
    points: "144.2,61.3 157.8,61.3 157.8,39.7 144.2,39.7 144.2,61.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000",
    points: "170.4,61.3 184.1,61.3 184.1,48.2 192.1,48.2 192.1,39.7 162.4,39.7 162.4,48.2 170.4,48.2                 170.4,61.3  "
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#000",
    d: "M214.8,52.6h-5.9l2.8-7.9h0.1L214.8,52.6L214.8,52.6z M192.5,61.3                 h13.9l1-2.8h9l0.9,2.8h14.1l-8.7-21.6h-21.6L192.5,61.3L192.5,61.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M266.5,50.3h-12.5v6h-2c-3.4,0-5.9-1.3-5.9-4.7c0-4.1,4.8-4.4,8.7-4.4c3.4,0,7.8,0.2,11.1,0.6v-7.6                 c-5.7-0.7-9.1-1.1-15.3-1.1c-9.9,0-18.2,2.7-18.2,11.5c0,8,7,11.3,17.6,11.3c6.9,0,11.3-0.6,16.3-1.9V50.3L266.5,50.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M280.3,43.4c0,2.7-2.1,4.9-4.8,4.9c-2.8,0-4.8-2.2-4.8-4.9c0-2.7,2.1-4.9,4.8-4.9                 C278.2,38.5,280.3,40.7,280.3,43.4L280.3,43.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M279.4,43.4c0-2.3-1.6-4-3.9-4c-2.4,0-3.9,1.7-3.9,4.1c0,2.3,1.6,4,3.9,4C277.8,47.5,279.4,45.7,279.4,43.4L279.4,43.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M276.6,43.8l0.9,2h-1l-0.9-1.9h-1v1.9h-0.9v-5.1h1.9c1,0,1.8,0.6,1.8,1.6C277.5,43,277.2,43.6,276.6,43.8                 L276.6,43.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M275.7,43.2c0.5,0,0.9-0.2,0.9-0.8c0-0.5-0.4-0.8-0.9-0.8h-1v1.6H275.7L275.7,43.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoReverse);
export default __webpack_public_path__ + "static/media/logo-reverse.914b22cc4e142947609f86d01366bfa2.svg";
export { ForwardRef as ReactComponent };